module.exports = __webpack_public_path__ + "static/media/fruits_40.2b01ce3f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_40.csv
// module id = 707
// module chunks = 0